import numeral from 'numeral'

export const formatNumber = (value: string | number, withDecimal = true): string => {
  const format = withDecimal ? '0,0.00' : '0,0'
  return numeral(value).format(format)
}
